import { Shadows } from '@mui/material/styles'

const shadows: Shadows = [
  'none',
  '0px 1px 2px rgba(0, 114, 255, 0.08), 0px 1px 3px 1px rgba(0, 114, 255, 0.12)',
  '0px 1px 2px rgba(0, 114, 255, 0.12), 0px 2px 6px 2px rgba(0, 114, 255, 0.08)',
  '0px 4px 8px 3px rgba(0, 114, 255, 0.12), 0px 1px 3px rgba(0, 114, 255, 0.08)',
  '0px 6px 12px 4px rgba(0, 114, 255, 0.12), 0px 2px 6px rgba(0, 114, 255, 0.12)',
  '0px 8px 16px 6px rgba(33, 123, 235, 0.08)',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
  'none',
]

export default shadows
